import { put, select, takeEvery } from 'redux-saga/effects';

import { INTERVENTION_PATHS_BY_TYPE } from 'constants/RoutesConstants';
import { ENTITY_TYPE } from 'modules/app/constants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { fetchInspections } from 'modules/interventions/actions/details';
import { actionTypeFormatter } from 'modules/sockets/actionTypes';
import { SOCKET_ACTION, SOCKET_TOPIC } from 'modules/sockets/constants';
import { concurrencyWatcher, subscribeOnPage } from 'modules/sockets/utils.middleware';

import { loadDetailsPageContent } from './details.saga';
import { getSelectedIntervention } from '../selectors';
import { getInterventionSubscription } from '../selectors/sockets';

const INTERVENTION_DETAIL_PATHS = Object.values(INTERVENTION_PATHS_BY_TYPE).flat();

export const isAuditCreatedAction = ({ payload }) =>
  payload?.entityType === ENTITY_TYPE.AUDIT && payload?.action === SOCKET_ACTION.AUDIT_CREATED;

function* refreshInspectionsOnAuditCreated({ payload }) {
  const originInterventionId = payload?.data?.originInterventionId;

  const { entityId: currentPageInterventionId } = yield select(getInterventionSubscription);
  const selected = yield select(getSelectedIntervention);
  const isPageAlreadyLoaded = currentPageInterventionId === originInterventionId && selected?.id === originInterventionId;

  if (isPageAlreadyLoaded) {
    yield put(fetchInspections(originInterventionId, selected.mode));
  }
}

export default function* interventionSockets() {
  // Initialize socket on page
  yield subscribeOnPage(INTERVENTION_DETAIL_PATHS, SOCKET_TOPIC.DETAILS, getInterventionSubscription);

  yield takeEvery(isAuditCreatedAction, refreshInspectionsOnAuditCreated);

  // Legacy intervention
  yield scopeToPage(
    INTERVENTION_PATHS_BY_TYPE[ENTITY_TYPE.INTERVENTION],
    concurrencyWatcher(
      actionTypeFormatter(SOCKET_TOPIC.DETAILS, ENTITY_TYPE.INTERVENTION, SOCKET_ACTION.INTERVENTION_UPDATE),
      loadDetailsPageContent,
    )
  );

  // Parts intervention
  yield scopeToPage(
    INTERVENTION_PATHS_BY_TYPE[ENTITY_TYPE.PARTS_INTERVENTION],
    concurrencyWatcher(
      actionTypeFormatter(SOCKET_TOPIC.DETAILS, ENTITY_TYPE.PARTS_INTERVENTION, SOCKET_ACTION.INTERVENTION_UPDATE),
      loadDetailsPageContent,
    )
  );
}
